<maximizer-outlook-notification #notification [closable]="true">
</maximizer-outlook-notification>

<kendo-dialog
  height="92%"
  width="95%"
  maxWidth="320px"
  (close)="closeDialog.emit()"
>
  <div class="reset px-2 py-1 flex justify-between items-center bg-neutral-10">
    <p class="subtitle-1 text-black">
      {{ 'outlook.iqBoost.questionLibrary' | translate }}
    </p>
    <button
      kendoButton
      themeColor="tertiary"
      iconClass="fa-icons icon-xmark icon-14"
      [attr.aria-label]="'outlook.buttons.close' | translate"
      class="small"
      (click)="closeDialog.emit()"
    ></button>
  </div>
  <div class="scrollbar overflow-y-auto p-3 flex-1 min-h-0 flex flex-col gap-2">
    @if (groupedPrompts().length > 0) {
      @for (group of groupedPrompts(); track group.key) {
        <button
          class="flex items-center justify-between w-full py-1 bg-transparent cursor-pointer"
          (click)="toggleGroup(group.key)"
        >
          <div class="flex items-center gap-1.5 text-black subtitle-2">
            <span [class]="group.iconStyle" class="icon-16"></span>
            <p>{{ group.label }}</p>
          </div>
          <span
            class="fa-icons icon-light icon-12 text-neutral-70"
            [class]="{
              'icon-chevron-up': !isGroupCollapsed(group.key),
              'icon-chevron-down': isGroupCollapsed(group.key),
            }"
          ></span>
        </button>

        @if (!isGroupCollapsed(group.key)) {
          <div
            animate.enter="slide-group-enter"
            animate.leave="slide-group-leave"
          >
            @for (item of group.items; track $index) {
              <button
                class="rounded w-full text-left p-2 hover:bg-bush-green-10 cursor-pointer bg-transparent"
                (click)="promptSelected.emit(item)"
              >
                <p class="text-body large text-neutral-90 pl-4">
                  {{ item.title }}
                </p>
              </button>
            }
          </div>
        }
      }
    }
    <button
      class="pt-2 text-link large text-left"
      (click)="showSuggestPrompt.set(true)"
    >
      {{ 'outlook.iqBoost.suggestPrompt.link' | translate }}
    </button>
  </div>
</kendo-dialog>

@if (showSuggestPrompt()) {
  <maximizer-outlook-suggest-prompt
    (closeDialog)="showSuggestPrompt.set(false)"
    (notifyResult)="onSuggestResult($event)"
  ></maximizer-outlook-suggest-prompt>
}
